export default "__VITE_ASSET__2a2016e1__"